import MatriculacionModal from "../matriculacion-modal/matriculacion-modal"
import Modal from "../_common/components/Modal"
import crypto from 'crypto'
import { connect } from "react-redux"
import { h, Fragment } from "preact"
import { isMobileAgent, isTwMd } from "../_common/common";
import { t } from '../_i18n'
import { toastService } from "../_services/toast-service"
import { useState, useEffect } from 'preact/hooks'
import Spinner from "../_common/components/Spinner"

import './trial-banner.scss'
import Badge from "../_common/components/Badge";
import ButtonSpinner from "../_common/components/buttons/buttonSpinner/buttonSpinner";

const TrialBanner = ({ buttonLabel, discountBadge, discountBadge1, discountSubtitle, discountTitle, discountTitle1, discountTitle2, endDate, modalTitle, showCountdown, startDate, studentMeta, user, style }) => {
    /** Variables **/
    const isPremiumUser = studentMeta?.has_whatsapp && studentMeta?.shop_id !== 24
    const isMad = studentMeta.formative_zone === 'MAD'
    const semesterId = isMad ? 90 : 84
    const start = new Date(studentMeta.trial_start_date)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    start.setHours(0, 0, 0, 0)
    const timeDifference = today - start
    const daysDifference = Math.max(Math.floor(timeDifference / (1000 * 60 * 60 * 24)), 0)
    const expirationMessage = t("trial_expiration").replace('{DAYS}', 15 - daysDifference)

    /** States **/
    const [showModal, setShowModal] = useState(false)
    const [loadingSkeleton, setLoadingSkeleton] = useState(false)
    const [loadingContinue, setLoadingContinue] = useState(false)
    const [cartData, setCartData] = useState(null)
    const [premiumSelected, setPremiumSelected] = useState(isPremiumUser)
    const [selectedProducts, setSelectedProducts] = useState([])
    const [cartDataAlreadyLoaded, setCartDataAlreadyLoaded] = useState()
    const [toValidate, setToValidate] = useState()
    const [cartUrl, setCartUrl] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    /** States **/
    const [timeLeft, setTimeLeft] = useState({
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
    });

    useEffect(() => {
        updateCountdown();
        const interval = setInterval(updateCountdown, 1000);
        return () => clearInterval(interval);
    }, []);

    /** Lifecycle **/
    useEffect(() => {
        getCartUrl()
        const resetLoading = () => setIsLoading(false)
        window.addEventListener("pageshow", resetLoading)
        return () => window.removeEventListener("pageshow", resetLoading)
    }, [])


    /** Methods **/
    const LoadingDots = () => {
        return (
          <span className="loading-dots">
            <span className="loading-dots__text">
              {t('Estamos preparando la información de tu matrícula')}
              <span className="loading-dots__animation"></span>
            </span>
          </span>
        );
    };

    const updateCountdown = () => {
        if (!endDate) {
            setTimeLeft({ days: "00", hours: "00", minutes: "00", seconds: "00" });
            return;
        }

        const now = Date.now();
        const end = new Date(endDate).getTime();
        const distance = end - now;

        if (distance <= 0) {
            setTimeLeft({ days: "00", hours: "00", minutes: "00", seconds: "00" });
            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((distance / (1000 * 60)) % 60);
        const seconds = Math.floor((distance / 1000) % 60);

        setTimeLeft({
            days: String(days).padStart(2, "0"),
            hours: String(hours).padStart(2, "0"),
            minutes: String(minutes).padStart(2, "0"),
            seconds: String(seconds).padStart(2, "0"),
        });
    };


    const normalizeDate = (date, endOfDay = false) => {
        return new Date(
          date?.year,
          date?.month - 1,
          date?.day,
          endOfDay ? 23 : 0,
          endOfDay ? 59 : 0,
          endOfDay ? 59 : 0,
        );
    };

    const startDateIsBeforeEndDay = () => {
        const start = startDate
          ? normalizeDate(startDate).getTime()
          : Number.NEGATIVE_INFINITY;

        const end = endDate
          ? normalizeDate(endDate, true).getTime()
          : Number.POSITIVE_INFINITY;

        const now = Date.now();

        return now >= start && now <= end;
    };

    const encryptString = (studentId) => {
        const cipher = crypto.createCipheriv(
            micuentaenv.ENCRYPTION_METHOD,
            adaptKey(micuentaenv.API_ADMIN_KEYWORD),
            micuentaenv.IV_ENCRYPTION_STRING
        )
        return encodeURIComponent(Buffer.from(
            cipher.update(studentId, 'utf8', 'base64') + cipher.final('base64')
        ).toString())
    }

    const adaptKey = (key) => {
        const len = 32
        if (key.length >= len) {
            return key.substring(0, len)
        } else {
            return key + Array(len - key.length + 1).join("\x00")
        }
    }


    const getCartUrl = async () => {
        try {
            const endpoint = `${micuentaenv.STUDENT_ACCOUNT_API_basePath}/get_cart_by_cis_id?cis_id=${studentMeta.cis_id}`

            const res = await fetch(endpoint, {
                headers: { accept: 'text/plain' },
                method: 'GET'
            })

            let finalUrl = await res.text()
            finalUrl = finalUrl + `&id_customer=${studentMeta.customer_id}`;

            setCartUrl(finalUrl)
        } catch (error) {
            console.error('Error fetching cart URL:', error)
        }
    }

    const openNewWindow = () => {
        setIsLoading(true)
        window.open(cartUrl, "_self")
    }

    const getCart = async (products = []) => {
        try {
            let baseUrl =
                `${micuentaenv.STUDENT_ACCOUNT_API_basePath}/get_recommended_cart_black_friday` +
                `?s=${encryptString(user.id.toString())}` +
                `&as=${semesterId}`

            if (products && Array.isArray(products) && products.length > 0) {
                const formattedProducts = products
                    .filter(p => !!p)
                    .join(',')
                const productsEncrypted = encryptString(formattedProducts)
                baseUrl += `&fa=${productsEncrypted}`
            } else {
                const emptyEncrypted = encryptString('')
                baseUrl += `&fa=${emptyEncrypted}`
            }

            const res = await fetch(baseUrl, {
                headers: { accept: 'application/json' },
                method: 'GET'
            })

            const data = await res.json()

            if (data.code && data.code !== 200) {
                throw new Error(data.message || 'Ha ocurrido un error')
            }

            return data
        } catch (error) {
            console.error("Error en getCart:", error?.message)
            toastService.showToast({ message: "Se ha producido un error al cargar el carrito", type: 'danger' })
            setShowModal(false)
            return null
        }
    }

    const handleCloseModal = () => {
        setCartDataAlreadyLoaded(true)
        setShowModal(false)
    }

    const handleCalculateDiscount = async (products, initial) => {
        if (initial) {
            setLoadingSkeleton(true)
            const cart = await getCart()
            setLoadingSkeleton(false)

            const recommendedIds = getRecommendedProducts(cart)
            setSelectedProducts(recommendedIds)

            setCartData(cart)
        } else {
            setLoadingContinue(true)
            const cart = await getCart(products)
            setLoadingContinue(false)

            setCartData(cart)
        }
    }

    const getRecommendedProducts = (cart) => {
        if (!cart?.semesters) return []
        return cart.semesters?.flatMap(({ products }) => {
            return products
                .filter((product) => product.price > 0)
                .filter((product) => product.is_recommended)
                .map((product) => product.id_product)
        })
    }

    const handleContinue = async () => {
        if (cartData.cartUrl) {
            window.open(cartData.cartUrl, "_blank")
        }
    }

    /** Return **/
    return (
      startDateIsBeforeEndDay() && (
          <Fragment>
              <div
                className={`flex-space-between flex flex-col bg-[${style?.backgroundColor}] p-8 text-white md:flex-row ${showCountdown ? "gap-6" : "gap-12"} m-x2-bottom`}
              >
                  <div
                    class={`flex flex-col gap-4 md:max-w-[${style?.textMaxWidth}px]`}
                  >
                      {discountTitle1 && discountTitle2 && isTwMd() ? (
                        <div className="flex flex-col font-bold">
                            <p className={`font-bold text-2xl md:text-4xl"}`}>{discountTitle1}</p>
                            <p className={`font-bold text-2xl md:text-4xl"}`}>{discountTitle2}</p>
                        </div>
                      ) : (
                        <p
                          className={`font-bold leading-none text-2xl md:text-4xl
                      ${style?.textCenter && "my-auto"}
                    `}
                        >
                            {discountTitle}
                        </p>
                      )}
                      {discountSubtitle && <p>{discountSubtitle}</p>}
                      <div>
                          {discountBadge && (
                            <Badge className="font-bold px-2 py-0 rounded-none text-black text-sm" type="dark-orange">
                                {discountBadge}
                            </Badge>
                          )}

                          {discountBadge1 && (
                            <Badge className="m-l font-bold px-2 py-0 rounded-none text-black text-sm" type="dark-orange">
                                {discountBadge1}
                            </Badge>
                          )}
                      </div>
                  </div>

                  <div
                    className={`flex flex-col gap-6 ${showCountdown ? "my-auto" : "mt-auto"}`}
                  >
                      {showCountdown && (
                        <div>
                            <strong className="block w-full text-center font-bold">
                                {t("La promoción acaba en...")}
                            </strong>
                            <div className="flex items-center justify-center gap-1">
                                <div>
                                    <p className="text-2xl font-bold">{timeLeft.days}</p>
                                    <p className="-mt-2">{t("días")}</p>
                                </div>
                                <div>
                                    <p className="">
                                        <strong>:</strong>
                                    </p>
                                </div>
                                <div>
                                    <p className="text-2xl font-bold">{timeLeft.hours}</p>
                                    <p className="-mt-2">{t("hrs")}</p>
                                </div>
                                <div>
                                    <p className="">
                                        <strong>:</strong>
                                    </p>
                                </div>
                                <div>
                                    <p className="text-2xl font-bold">{timeLeft.minutes}</p>
                                    <p className="-mt-2">{t("mins")}</p>
                                </div>
                                <div>
                                    <p className="">
                                        <strong>:</strong>
                                    </p>
                                </div>
                                <div>
                                    <p className="text-2xl font-bold">{timeLeft.seconds}</p>
                                    <p className="-mt-2">{t("segs")}</p>
                                </div>
                            </div>
                        </div>
                      )}
                      <ButtonSpinner
                        showSpinner={loadingContinue}
                        onClick={openNewWindow}
                        btnType='primary-highlight'
                        classNameContainer="w-full flex justify-center"
                        className={`flex font-bold items-center justify-center min-w-full pb-3 pt-3.5 px-0 py-3 whitespace-nowrap md:min-w-[${style?.buttonWidth}px]`}
                        iconClassName="text-black"
                      >
                          {t("¡Matricúlate ahora!")}
                      </ButtonSpinner>
                  </div>
              </div>

              <Modal
                visible={showModal}
                closeModal={handleCloseModal}
                overlayClass="modal-overlay trial-banner-overlay"
              >
                  <MatriculacionModal
                    cartData={cartData}
                    cartDataAlreadyLoaded={cartDataAlreadyLoaded}
                    isPremiumUser={isPremiumUser}
                    loadingContinue={loadingContinue}
                    loadingSkeleton={loadingSkeleton}
                    onCalculateDiscount={handleCalculateDiscount}
                    onCloseModal={handleCloseModal}
                    onContinue={handleContinue}
                    premiumSelected={premiumSelected}
                    selectedProducts={selectedProducts}
                    setLoadingContinue={setLoadingContinue}
                    setPremiumSelected={setPremiumSelected}
                    setSelectedProducts={setSelectedProducts}
                    setToValidate={setToValidate}
                    title={t('Matriculación 2026')}
                    toValidate={toValidate}
                  />
              </Modal>
              <Modal
                visible={isLoading}
                bodyClass="relative p-4"
              >
                  <Spinner className="mt-8" />
                  <div className="trial-banner-loading-text mb-0 mt-18">
                      <LoadingDots />
                  </div>
              </Modal>
          </Fragment>
      )
    )
}

/** Redux Container **/
const TrialBannerContainer = connect(
    ({ auth, status, general }) => ({
        user: auth.loggedUser,
        studentMeta: status.student_meta,
        helpModeStep: general.helpModeStep
    }),
    {}
)(TrialBanner)

/** Export **/
export default TrialBannerContainer
